// отделяем необходимые пропсы для передачи в компонент
var getListBottomSheetMobileProps = function (props) {
    var BottomSheet = props.BottomSheet, dataTestId = props.dataTestId, label = props.label, placeholder = props.placeholder, footer = props.footer, swipeable = props.swipeable, showSearch = props.showSearch, bottomSheetProps = props.bottomSheetProps, _a = props.isBottomSheet, isBottomSheet = _a === void 0 ? true : _a, _b = props.nativeSelect, nativeSelect = _b === void 0 ? false : _b, onScroll = props.onScroll;
    return {
        BottomSheet: BottomSheet,
        dataTestId: dataTestId,
        label: label,
        placeholder: placeholder,
        footer: footer,
        swipeable: swipeable,
        showSearch: showSearch,
        bottomSheetProps: bottomSheetProps,
        isBottomSheet: isBottomSheet,
        nativeSelect: nativeSelect,
        onScroll: onScroll,
    };
};

export { getListBottomSheetMobileProps };
